import React from "react";
import SliderCore from './SliderCore';
import './index.scss';

export default class Slider extends React.Component {
    static defaultProps = {
        resp: [
            { breakpoint: 768, slidesToShow: 2 },
            { breakpoint: 992, slidesToShow: 3 }
        ],
        noslid: 576
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            slidesToShow: 1,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize, false);
        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    render() {
        const noslidClassName = this.state.docWidth < this.props.noslid ? ' pubhub-resp-slider-noslid' : ''; 

        return (
            <div className={'pubhub-resp-slider' + noslidClassName}>
                <div className='container'>
                    <div className='pubhub-resp-slider-box'>
                        <div className="pubhub-resp-slider-prev" onClick={this.onPrev}></div>
                        <div className="pubhub-resp-slider-next" onClick={this.onNext}></div>
                        <SliderCore
                            autoPlay={this.props.autoPlay}
                            slidesToShow={this.state.slidesToShow} ref={dom => this.slider = dom}>
                            {this.props.children}
                        </SliderCore>
                    </div>
                </div>
            </div>
        );
    }

    onPrev = () => {
        this.slider.slideRight();
    }

    onNext = () => {
        this.slider.slideLeft();
    }

    onResize = () => {
        var width = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        let slidesToShow = 1;
        let resp = this.props.resp || [];
        resp.forEach(i => {
            if (width >= i.breakpoint) {
                slidesToShow = i.slidesToShow;
            }
        });

        this.setState({ slidesToShow: slidesToShow, docWidth: width });
    }
}